import { MyLeadsSearchQuery } from '@mm/state/interfaces/myLeads';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

export const useCreateFilterParams = (defaultParams?: MyLeadsSearchQuery) => {
  const location = useLocation<MyLeadsSearchQuery>();
  const properties = ['query', 'filterParams', 'tagsFilters'];
  const filteredLocationState = Object.keys(location.state || {})
    .filter(key => properties.includes(key))
    .reduce((filtered, key) => {
      filtered[key] = location.state[key];
      return filtered;
    }, {});

  const hasLocationState = !!Object.keys(filteredLocationState || {}).length;

  const initialFilters = hasLocationState
    ? filteredLocationState
    : defaultParams || {};

  const [filterParams, setFilterParams] =
    useState<MyLeadsSearchQuery>(initialFilters);

  useEffect(() => {
    if (hasLocationState) {
      setFilterParams(prevParams => {
        const shouldUpdate =
          JSON.stringify(prevParams) !== JSON.stringify(filteredLocationState);
        return shouldUpdate ? filteredLocationState : prevParams;
      });
    }
  }, [hasLocationState, filteredLocationState]);

  useEffect(() => {
    if (!hasLocationState) {
      setFilterParams(prevParams => {
        const shouldUpdate =
          JSON.stringify(prevParams) !== JSON.stringify(defaultParams);
        return shouldUpdate ? defaultParams || {} : prevParams;
      });
    }
  }, [defaultParams, hasLocationState]);

  return {
    filterParams,
    setFilterParams,
  };
};
